<template>
  <div style="position:fixed;bottom:0px;width:100%;">
    <mt-tabbar v-model="checkedId">
      <mt-tab-item id="0" @click.native="tabClick(0)"><i slot="icon" class="iconfont icon-ysshouye2"></i>首页</mt-tab-item>
      <mt-tab-item id="1" @click.native="tabClick(1)"><i slot="icon" class="iconfont icon-748bianjiqi_shipin"></i>录播课</mt-tab-item>
      <mt-tab-item id="2" @click.native="tabClick(2)"><i slot="icon" class="iconfont icon-shipinjiankong"></i>直播课</mt-tab-item>
      <mt-tab-item id="3" @click.native="tabClick(3)"><i slot="icon" class="iconfont icon-ziliaotaizhang"></i>资料库</mt-tab-item>
      <mt-tab-item id="4" @click.native="tabClick(4)"><i slot="icon" class="iconfont icon-gerenzhongxin"></i>我的</mt-tab-item>
    </mt-tabbar>
  </div>
</template>

<script>
export default {
  props: ["active"],
  data () {
    return {
      checkedId: "0"
    }
  },
  mounted () {
    this.checkedId = this.active;
  },
  methods: {
    tabClick (index) {
      if (index == 0) { this.$router.push({ name: "shopIndex" }); return; }
      if (index == 1) { this.$router.push({ name: "resList" }); return; }
      if (index == 2) { window.location = "http://xcx.maitiange.com/Demo/live/Default.aspx?operId=" + this.$route.query.operId; return; }
      if (index == 3) { this.$router.push({ name: "libIndex" }); return; }
      if (index == 4) { this.$router.push({ name: "userCenter" }); return; }
    }
  }
}
</script>
<style lang="scss" scoped>
.mint-tabbar {
  .mint-tab-item {
    color: auto;
    text-decoration: none;
  }
  .is-selected {
    color: #26a2ff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/footerNav.vue